<template>
  <div class="searchMatter">
    <headers class="herderNav" ref="header" :isChange="false"/>
    <div class="onlineNav">
      <div class="searchNav">
        <h1>海量GMAT题库 · 做题搜题一网打尽</h1>
        <div class="titTag">
          <a class="scoreTag">题库总题数9k+</a>
          <a>模考仿真度99%</a>
          <a class="scoreLast">题库更新频率day by day</a>
        </div>
        <div class="searchInput">
          <input v-model="inputVal" @focus="hidden" @keyup.enter="searchTopic" placeholder="搜索包括不限于以下题源：OG PREP破解版（07/08/12） GWD Manhattan Advanced 300 杨鹏长难句……等市面全部主流题源" />
          <img src="../../assets/home/searchIcon.jpg" class="searchIcon" @click="searchTopic">
        </div>
        <div class="searchText">部分题源会配备真人视频逐题讲解哦，做GMAT，我们是用心的</div>
      </div>
    </div>
    <div class="searchCon" v-if="existVal">
      <div class="seacherCard" v-for="(ele,index) in searchList" :key="index" @click="nav(ele.id)">
        <h1>{{ele.title}}</h1>
        <p>来源: {{ele.c_id}}</p>
        <div class="cardText">{{ele.stem}}</div>
        <div class="cardPerson">
          <p>{{ele.peoplenum}}人做过</p>
          <div class="cardCollect">
            <div v-show="ele.collect == 1" @click="cancelCollect(ele.id)" style="display: flex;align-items: center;cursor: pointer;">
              <img src="../../assets/allSubject/choiceCollect.png">
              <span>取消收藏</span>
            </div>
            <div v-show="ele.collect == 0" @click="needCollect(ele.id)" style="display: flex;align-items: center;cursor: pointer;">
              <img src="../../assets/cancleCollectIcon.png">
              <span>收藏</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="searchCon nullVal" v-if="nullVals">没有找到与{{inputVal}}相关的结果尝试使用推荐搜索，搜索更多题目</div>
  </div>
</template>

<script>
  import api from '../../api/subject.js'
  import headers from '../../components/header.vue'
  export default {
    components: {
      headers
    },
    data() {
      return {
        navCodes: require('@/assets/login/whiteCode.png'),
        headerIcon: require('@/assets/bottom/bottomIcon.png'),
        inputVal: '',
        existVal: false,
        nullVals: false,
        searchList: []
      }
    },
    mounted() {
      this.$refs.header.isTop=false
      this.$refs.header.headerBack.background = '#ffffff';
      this.$refs.header.herderTits.color = '#666666';
      this.$refs.header.headerIcon = require('@/assets/home/headerNav.png');
      this.$refs.header.loginButton = {
         background : '#618aff',
         color:'#fff'
      }
      this.$refs.header.phoneButton = {
      color:'#618aff',
      border: '1px solid #618aff'
       }
      // api.baseParams().then(res => {
      //   console.log(res)
      // })
       this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
    })
    },
    methods: {
      nav(id){
        console.log(id);
        this.$router.push(`/libraryContent/${id}`);
      },
      //隐藏搜索结果框
      hidden() {
        this.existVal = this.nullVals = false
      },
      //加入收藏
      needCollect(id) {
        let params = {
          id: id
        }
        let query = this.$qs.stringify(params)
        api.joinCollect(query).then(res => {
            this.searchTopic()
            this.$message.success('收藏成功')
          })
          .catch(err => {
            this.$message.error('收藏失败')
          })
      },
      //取消收藏
      cancelCollect(id) {
        let params = {
          id: id
        }
        let query = this.$qs.stringify(params)
        api.outCollect(query).then(res => {
          this.searchTopic()
          this.$message.success('取消收藏成功')
          })
          .catch(err => {
            this.$message.error('取消收藏失败')
          })
      },
      //搜索结果
      searchTopic() {
        if (this.inputVal) {
          let params = {
            keyword: this.inputVal
          }
          let query = this.$qs.stringify(params)
          api.searchTopic(query).then(res => {
              if (res.data.data.topics == '') {
                this.nullVals = true
              } else {
                this.existVal = true
                this.searchList = res.data.data.topics;
				console.log( this.searchList)
              }
            })
            .catch(err => {
              this.$message.error('搜索失败')
            })
        }
      }
    }
  }
</script>

<style scoped>
 @import '../../assets/css/searchMatter.css';
</style>



// WEBPACK FOOTER //
// src/view/questionBank/searchMatter.vue